import {
  FETCHED_PROJECTS,
  FETCHED_PROJECT,
  ENABLE_PROJECT_TIMELINE,
  PROJECT_DELETED,
  UPDATE_SETTING_FIELD,
  TAGS_ADDED_TO_PROJECT,
  PROJECT_REPORTS_COUNT_DECREMENT,
  PROJECT_SET_PAYMENT_REQUESTS_COUNT,
} from 'constants/actions';
import { FEED_TYPE } from 'constants/settingsFields';

const initialState = {
  projectsById: {},
};

export default function projects(state = initialState, action = {}) {
  switch (action.type) {
    case FETCHED_PROJECTS:
      return {
        ...state,
        projectsById: action.projects.reduce(
          (memo, project) => {
            return {
              ...memo,
              [project.id]: { ...project },
            };
          },
          { ...state.projectsById },
        ),
      };
    case FETCHED_PROJECT:
      return {
        ...state,
        projectsById: [action.project].reduce(
          (memo, project) => {
            return {
              ...memo,
              [project.id]: { ...project },
            };
          },
          { ...state.projectsById },
        ),
      };
    case ENABLE_PROJECT_TIMELINE:
      return {
        ...state,
        projectsById: {
          ...state.projectsById,
          [action.projectId]: {
            ...state.projectsById[action.projectId],
            public: action.enabled,
          },
        },
      };
    case PROJECT_DELETED:
      return [action.projectId].reduce(
        (memo, projectId) => {
          const nextMemo = { ...memo };
          delete nextMemo.projectsById[projectId];
          return nextMemo;
        },
        { ...state, projectsById: { ...state.projectsById } },
      );
    case PROJECT_REPORTS_COUNT_DECREMENT: {
      const project = state.projectsById[action.projectId];
      const newCount = Math.max(project.reports_count - 1, 0);

      return {
        ...state,
        projectsById: {
          ...state.projectsById,
          [action.projectId]: {
            ...state.projectsById[action.projectId],
            reports_count: newCount,
          },
        },
      };
    }
    case UPDATE_SETTING_FIELD:
      if (action.field === FEED_TYPE) {
        return initialState;
      }
      return state;
    case TAGS_ADDED_TO_PROJECT:
      return {
        ...state,
        projectsById: action.projectIds.reduce(
          (memo, projectId) => {
            return {
              ...memo,
              [projectId]: {
                ...memo[projectId],
              },
            };
          },
          { ...state.projectsById },
        ),
      };
    case PROJECT_SET_PAYMENT_REQUESTS_COUNT:
      return {
        ...state,
        projectsById: {
          ...state.projectsById,
          [action.projectId]: {
            ...state.projectsById[action.projectId],
            payment_requests_count: action.paymentsCount,
          },
        },
      };
    default:
      return state;
  }
}
